import script from "./PriceAndViewDetailsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceAndViewDetailsButton.vue?vue&type=script&setup=true&lang=ts"

import "./PriceAndViewDetailsButton.vue?vue&type=style&index=0&id=12c5e841&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c5e841"]])

export default __exports__